import React, { useEffect } from 'react';
import { useLmxStore } from './lmxStore';
import LmxDock from './LmxDock';
import LmxTourGate from './LmxTourGate';
import useTimelineStore from '../store/timelineStore';
import { DEFAULT_ASSETS } from './assets';

/**
 * LmxLab — pantalla SÓLO de desarrollo (REACT_APP_LMX_LAB=true) para mirar la
 * capa de Lumière sin pasar por Clerk, que en pruebas headless pide 2FA.
 * No habla con el backend: carga un turno de ejemplo en el store.
 */
const SAMPLE = {
  text: 'Armo el flujo para Café Andino en tu canvas. Te cuento qué pongo.',
  cards: [
    { type: 'summary', fields: { Tipo: 'Video', Formato: '9:16', Duración: '15 s', Tono: 'Cálido' } },
    {
      type: 'flow',
      diff: '+3 nodos · +2 conexiones',
      nodes: [
        { id: 'n1', label: 'Cargar Imagen', meta: 'producto.png' },
        { id: 'n3', label: 'Banana 2 Pro', meta: 'taza humeante', state: 'new' },
        { id: 'n4', label: 'Seedance 2.5', meta: '6 s · 9:16', state: 'changed' },
      ],
    },
    {
      type: 'progress',
      items: [
        { label: 'Referencia de marca', sub: 'Quitar fondo · node_12', state: 'ok', meta: '1 cr' },
        { label: 'Foto del producto', sub: 'Banana 2 Pro · node_13', state: 'go', meta: '' },
        { label: 'Voz en off', sub: 'ElevenLabs · node_16', state: 'bad', meta: 'sin saldo' },
      ],
    },
    {
      type: 'cost',
      rows: [['Fotos y referencias', 4, 7], ['Voces y música', 3, 12], ['Video y avatar', 2, 17]],
      total: 36,
      note: 'Saldo: 240 créditos. Después de todo te quedan 204.',
    },
    {
      type: 'chips',
      items: [
        { label: 'Generar etapa 1 · 7 cr', primary: true },
        { label: 'Generar todo · 36 cr' },
        { label: 'Más barato' },
      ],
    },
  ],
};

export default function LmxLab() {
  useEffect(() => {
    // El editor de timeline queda abierto de una corrida anterior (localStorage):
    // si está abierto y grande, el dock se pliega solo por diseño.
    useTimelineStore.setState({ isOpen: false });
    useLmxStore.setState({
      ready: true,
      available: true,
      assets: DEFAULT_ASSETS,
      prefs: { language: 'es', exec_permission: true, voice_enabled: false },
      limits: { daily_turn_limit: 50, turns_today: 3 },
      model: 'claude-sonnet-5',
      greeted: false,
      turn: SAMPLE,
      log: [
        { who: 'Vos', text: 'Quiero un reel de 15 s para Café Andino.' },
        { who: 'Lumière', text: SAMPLE.text },
      ],
      status: { text: 'Armando el flujo…', active: true, warn: false },
      pose: 'work',
      pendingConfirm: {
        id: 'lab-confirm-1',
        summary: 'Generar la foto del producto (Banana 2 Pro) y la voz en off',
        cost: 14,
        action: 'execute_workflow',
      },
    });
  }, []);

  return (
    <div style={{
      minHeight: '100vh', background: '#0d1017',
      backgroundImage: 'radial-gradient(rgba(255,255,255,.07) 1px, transparent 1px)',
      backgroundSize: '22px 22px',
    }}
    >
      <div style={{
        height: 56, display: 'flex', alignItems: 'center', gap: 14, padding: '0 18px',
        background: '#121620', borderBottom: '1px solid rgba(255,255,255,.08)',
        color: '#9aa0ad', fontSize: 13,
      }}
      >
        <b style={{ color: '#eef0f4' }}>Studio Media Labs</b>
        <span>LMX Lab (sólo desarrollo)</span>
      </div>
      <div className="studio-main" style={{ height: 'calc(100vh - 56px)' }} />
      <LmxDock />
      <LmxTourGate />
    </div>
  );
}
